module.exports = __webpack_public_path__ + "static/media/icon_gps.5cce72b9.svg";